module.exports = __webpack_public_path__ + "static/media/logo_en.4a4746ed.svg";